// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimPostingInfoDto
 */
export interface IClaimPostingInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimPostingInfoDto
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimPostingInfoDto
     */
    account_type: IClaimPostingInfoDtoAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IClaimPostingInfoDto
     */
    transaction_type: IClaimPostingInfoDtoTransactionTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IClaimPostingInfoDto
     */
    transaction_at: Date;
}

/**
* @export
* @enum {string}
*/
export enum IClaimPostingInfoDtoAccountTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}
/**
* @export
* @enum {string}
*/
export enum IClaimPostingInfoDtoTransactionTypeEnum {
    NOTIONAL_FUND = 'NOTIONAL_FUND',
    REPLENISHMENT_PAYMENT = 'REPLENISHMENT_PAYMENT',
    REPLENISHMENT = 'REPLENISHMENT',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    CARD_SETTLEMENT = 'CARD_SETTLEMENT',
    PAY_CLAIM = 'PAY_CLAIM',
    CHECK_CLEARED = 'CHECK_CLEARED',
    CARD_PROCESSOR_PAYMENT = 'CARD_PROCESSOR_PAYMENT',
    RECORD_KEEPING_PAYROLL = 'RECORD_KEEPING_PAYROLL',
    CONTRIBUTION_PAYMENT = 'CONTRIBUTION_PAYMENT',
    PAYROLL = 'PAYROLL',
    EMPLOYER_PAYMENT = 'EMPLOYER_PAYMENT',
    PAYMENT = 'PAYMENT',
    INTEREST = 'INTEREST',
    FEE = 'FEE',
    TRANSFER_OF_ASSETS = 'TRANSFER_OF_ASSETS',
    INVESTMENT = 'INVESTMENT',
    ACH_CLEARED = 'ACH_CLEARED',
    DEBIT_CLEARED = 'DEBIT_CLEARED',
    VENMO_CLEARED = 'VENMO_CLEARED',
    PAYPAL_CLEARED = 'PAYPAL_CLEARED',
    ADJUSTMENT = 'ADJUSTMENT',
    INTEREST_PAYMENT = 'INTEREST_PAYMENT',
    BUY_INVESTMENT = 'BUY_INVESTMENT',
    SELL_INVESTMENT = 'SELL_INVESTMENT',
    BUY_INVESTMENT_CLEARED = 'BUY_INVESTMENT_CLEARED',
    SELL_INVESTMENT_CLEARED = 'SELL_INVESTMENT_CLEARED',
    CLAIM_REPAYMENT = 'CLAIM_REPAYMENT',
    LOCKBOX_PAYMENT = 'LOCKBOX_PAYMENT',
    PAYMENT_CARD_RETURN = 'PAYMENT_CARD_RETURN',
    ROLLOVER = 'ROLLOVER',
    DIGITAL_SETTLEMENT = 'DIGITAL_SETTLEMENT',
    DEBIT_VENMO_PAYPAL_REJECTED = 'DEBIT_VENMO_PAYPAL_REJECTED',
    RETURN_REPLENISHMENT_PAYMENT = 'RETURN_REPLENISHMENT_PAYMENT',
    RECORD_KEEPING = 'RECORD_KEEPING',
    CONTRIBUTION_PAID = 'CONTRIBUTION_PAID',
    PREFUND_REPLENISHMENT = 'PREFUND_REPLENISHMENT',
    INTERNAL_TRANSFER_OF_ASSETS = 'INTERNAL_TRANSFER_OF_ASSETS',
    HSA_INCOMING_CONTRIBUTION = 'HSA_INCOMING_CONTRIBUTION',
    HSA_ROLLOVER = 'HSA_ROLLOVER',
    ORPHAN_EE_FEE = 'ORPHAN_EE_FEE',
    ORPHAN_EE_FEE_PAYMENT = 'ORPHAN_EE_FEE_PAYMENT',
    ADMIN_FEE = 'ADMIN_FEE',
    ADMIN_FEE_PAYMENT = 'ADMIN_FEE_PAYMENT',
    REPLENISHMENT_REVERSE = 'REPLENISHMENT_REVERSE',
    ACH_REJECTED = 'ACH_REJECTED',
    RETURN_CONTRIBUTION_PAYMENT = 'RETURN_CONTRIBUTION_PAYMENT',
    HSA_INCOMING_CONTRIBUTION_REVERSE = 'HSA_INCOMING_CONTRIBUTION_REVERSE',
    HSA_ROLLOVER_REVERSE = 'HSA_ROLLOVER_REVERSE',
    INVESTMENT_FEES = 'INVESTMENT_FEES',
    REPLENISHMENT_FUNDING_REVERSE = 'REPLENISHMENT_FUNDING_REVERSE',
    RETURN_REPLENISHMENT_FUNDING_PAYMENT = 'RETURN_REPLENISHMENT_FUNDING_PAYMENT',
    CLAIM_TRANSFER = 'CLAIM_TRANSFER',
    CLAIM_TRANSFER_INTERNAL = 'CLAIM_TRANSFER_INTERNAL',
    PAYROLL_REVERSE = 'PAYROLL_REVERSE',
    CONTRIBUTION_PAID_REVERSE = 'CONTRIBUTION_PAID_REVERSE',
    CONTRIBUTION_REVERSE_PAYMENT = 'CONTRIBUTION_REVERSE_PAYMENT',
    PREFUND_REPLENISHMENT_RETURN = 'PREFUND_REPLENISHMENT_RETURN',
    FINAL_PREFUND_REPLENISHMENT_RETURN = 'FINAL_PREFUND_REPLENISHMENT_RETURN',
    PREFUND_PAYMENT = 'PREFUND_PAYMENT',
    PREFUND_INTER = 'PREFUND_INTER',
    RETURN_PREFUND_FUNDING_PAYMENT = 'RETURN_PREFUND_FUNDING_PAYMENT',
    PREFUND_FINAL = 'PREFUND_FINAL',
    PREFUND_FUNDING_REVERSE = 'PREFUND_FUNDING_REVERSE',
    RETURN_LOCKBOX = 'RETURN_LOCKBOX',
    INBOUND_CHECK_CLEARED = 'INBOUND_CHECK_CLEARED',
    LOCKBOX_INCOMING = 'LOCKBOX_INCOMING',
    INBOUND_TRANSFER_OF_ASSETS = 'INBOUND_TRANSFER_OF_ASSETS',
    OUTBOUND_TRANSFER_OF_ASSETS = 'OUTBOUND_TRANSFER_OF_ASSETS',
    OUTBOUND_CHECK_CLEARED = 'OUTBOUND_CHECK_CLEARED',
    CLAIM_OFFSET = 'CLAIM_OFFSET',
    WRITE_OFF = 'WRITE_OFF',
    FORFEITURE = 'FORFEITURE',
    PUSH_REPLENISHMENT_PAYMENT = 'PUSH_REPLENISHMENT_PAYMENT',
    PUSH_PREFUND_PAYMENT = 'PUSH_PREFUND_PAYMENT',
    PUSH_CONTRIBUTION_PAYMENT = 'PUSH_CONTRIBUTION_PAYMENT',
    PAYMENT_EE_FEE = 'PAYMENT_EE_FEE',
    ACCOUNT_MAINTENANCE_EE_FEE = 'ACCOUNT_MAINTENANCE_EE_FEE',
    PAPER_STATEMENT_EE_FEE = 'PAPER_STATEMENT_EE_FEE',
    EE_FEES_BULK_PAYMENT = 'EE_FEES_BULK_PAYMENT',
    OTHER_ROOT_INTERNAL_TRANSFER_OF_ASSETS = 'OTHER_ROOT_INTERNAL_TRANSFER_OF_ASSETS',
    FEE_TRANSFER_INTERNAL = 'FEE_TRANSFER_INTERNAL',
    FEE_TRANSFER = 'FEE_TRANSFER',
    CLAIM_REJECTION = 'CLAIM_REJECTION',
    ACH_CLAIM_REPAYMENT = 'ACH_CLAIM_REPAYMENT',
    ACH_CLAIM_REPAYMENT_REJECTED = 'ACH_CLAIM_REPAYMENT_REJECTED',
    CLAIM_REPAYMENT_REJECTION = 'CLAIM_REPAYMENT_REJECTION',
    CLAIM_REPAYMENT_TRANSFER_INTERNAL = 'CLAIM_REPAYMENT_TRANSFER_INTERNAL',
    CLAIM_REPAYMENT_TRANSFER = 'CLAIM_REPAYMENT_TRANSFER',
    LOCKBOX_CHECK_CLEARED = 'LOCKBOX_CHECK_CLEARED',
    LOCKBOX_CLAIM_REPAYMENT = 'LOCKBOX_CLAIM_REPAYMENT',
    NOTIONAL_CONTRIBUTION_PAID = 'NOTIONAL_CONTRIBUTION_PAID',
    PREFUND_RETURN_PAYMENT_REVERSE = 'PREFUND_RETURN_PAYMENT_REVERSE',
    CLAIM_BALANCE_ADJUSTMENT = 'CLAIM_BALANCE_ADJUSTMENT',
    NOTIONAL_CONTRIBUTION_PAID_REVERSE = 'NOTIONAL_CONTRIBUTION_PAID_REVERSE',
    ROLLOVER_BALANCE_ADJUSTMENT = 'ROLLOVER_BALANCE_ADJUSTMENT',
    EOY_PLAN_FUNDS_INTERNAL_RETURN = 'EOY_PLAN_FUNDS_INTERNAL_RETURN',
    PUSH_RETURN_PAYMENT = 'PUSH_RETURN_PAYMENT',
    HSA_INCOMING_CONTRIBUTION_PAYMENT = 'HSA_INCOMING_CONTRIBUTION_PAYMENT',
    NOTIONAL_PAYROLL_REVERSE = 'NOTIONAL_PAYROLL_REVERSE',
    EOY_PLAN_FUNDS_INTERNAL_RETURN_PAYMENT = 'EOY_PLAN_FUNDS_INTERNAL_RETURN_PAYMENT',
    EOY_PLAN_FUNDS_EXTERNAL_RETURN = 'EOY_PLAN_FUNDS_EXTERNAL_RETURN',
    EOY_PLAN_FUNDS_EXTERNAL_RETURN_PAYMENT = 'EOY_PLAN_FUNDS_EXTERNAL_RETURN_PAYMENT',
    EOY_PLAN_FUNDS_EXTERNAL_RETURN_PAYMENT_REVERSE = 'EOY_PLAN_FUNDS_EXTERNAL_RETURN_PAYMENT_REVERSE',
    EOY_PLAN_SHORTAGE_COLLECTION = 'EOY_PLAN_SHORTAGE_COLLECTION',
    EOY_PLAN_SHORTAGE_COLLECTION_PULL_PAYMENT = 'EOY_PLAN_SHORTAGE_COLLECTION_PULL_PAYMENT',
    EOY_PLAN_SHORTAGE_COLLECTION_PULL_PAYMENT_REVERSE = 'EOY_PLAN_SHORTAGE_COLLECTION_PULL_PAYMENT_REVERSE',
    EOY_PLAN_SHORTAGE_COLLECTION_PUSH_PAYMENT = 'EOY_PLAN_SHORTAGE_COLLECTION_PUSH_PAYMENT',
    PUSH_UNKNOWN_PAYMENT = 'PUSH_UNKNOWN_PAYMENT',
    UNMATCHED_PUSH_KEEPING = 'UNMATCHED_PUSH_KEEPING',
    PUSH_INVOICE_PAYMENT = 'PUSH_INVOICE_PAYMENT',
    UNMATCHED_PUSH_RETURN = 'UNMATCHED_PUSH_RETURN',
    CLAIM_BALANCE_ADJUSTMENT_EXTERNAL = 'CLAIM_BALANCE_ADJUSTMENT_EXTERNAL',
    ROLLOVER_BALANCE_ADJUSTMENT_CROSS_OMNIBUS = 'ROLLOVER_BALANCE_ADJUSTMENT_CROSS_OMNIBUS',
    ROLLOVER_BALANCE_ADJUSTMENT_EXTERNAL = 'ROLLOVER_BALANCE_ADJUSTMENT_EXTERNAL',
    BULK_BALANCE_ADJUSTMENT = 'BULK_BALANCE_ADJUSTMENT',
    BULK_BALANCE_ADJUSTMENT_PULL_PAYMENT = 'BULK_BALANCE_ADJUSTMENT_PULL_PAYMENT',
    BULK_BALANCE_ADJUSTMENT_PUSH_PAYMENT = 'BULK_BALANCE_ADJUSTMENT_PUSH_PAYMENT',
    BULK_BALANCE_ADJUSTMENT_PULL_PAYMENT_REVERSE = 'BULK_BALANCE_ADJUSTMENT_PULL_PAYMENT_REVERSE',
    BULK_BALANCE_ADJUSTMENT_REVERSE = 'BULK_BALANCE_ADJUSTMENT_REVERSE',
    CLAIM_BALANCE_ADJUSTMENT_EXTERNAL_REVERSE = 'CLAIM_BALANCE_ADJUSTMENT_EXTERNAL_REVERSE',
    ROLLOVER_BALANCE_ADJUSTMENT_EXTERNAL_REVERSE = 'ROLLOVER_BALANCE_ADJUSTMENT_EXTERNAL_REVERSE',
    BULK_BALANCE_ADJUSTMENT_RETURN_PAYMENT = 'BULK_BALANCE_ADJUSTMENT_RETURN_PAYMENT',
    BULK_BALANCE_ADJUSTMENT_RETURN_PAYMENT_REVERSE = 'BULK_BALANCE_ADJUSTMENT_RETURN_PAYMENT_REVERSE'
}


/**
 * Check if a given object implements the IClaimPostingInfoDto interface.
 */
export function instanceOfIClaimPostingInfoDto(value: object): value is IClaimPostingInfoDto {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('account_type' in value) || value['account_type'] === undefined) return false;
    if (!('transaction_type' in value) || value['transaction_type'] === undefined) return false;
    if (!('transaction_at' in value) || value['transaction_at'] === undefined) return false;
    return true;
}

export function IClaimPostingInfoDtoFromJSON(json: any): IClaimPostingInfoDto {
    return IClaimPostingInfoDtoFromJSONTyped(json, false);
}

export function IClaimPostingInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimPostingInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'account_type': json['account_type'],
        'transaction_type': json['transaction_type'],
        'transaction_at': (new Date(json['transaction_at'])),
    };
}

export function IClaimPostingInfoDtoToJSON(json: any): IClaimPostingInfoDto {
    return IClaimPostingInfoDtoToJSONTyped(json, false);
}

export function IClaimPostingInfoDtoToJSONTyped(value?: IClaimPostingInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'account_type': value['account_type'],
        'transaction_type': value['transaction_type'],
        'transaction_at': ((value['transaction_at']).toISOString()),
    };
}

